import React from 'react'

import { observer } from 'mobx-react'
import { Layer, Source } from 'react-map-gl/mapbox'

import { IRemoteTileset } from '~/client/graph'

import {
  REMOTE_TILESET_LAYER,
  REMOTE_TILESET_LAYER_PREFIX,
} from '../../../MapBoxViewer/mapboxConstants'

interface IProps {
  mapboxWMSTileset: IRemoteTileset
  isHidden?: boolean
}

@observer
export default class GlobeViewRemoteTileset extends React.Component<IProps> {
  public render(): JSX.Element {
    return this.renderGlobeRemoteTilesets()
  }

  private get layerId(): string {
    return REMOTE_TILESET_LAYER_PREFIX + this.props.mapboxWMSTileset.id
  }

  private get sourceId(): string {
    return REMOTE_TILESET_LAYER + this.props.mapboxWMSTileset.id
  }

  private get tiles(): string[] {
    const { source } = this.props.mapboxWMSTileset
    try {
      return [decodeURIComponent(source)]
    } catch (e) {
      console.error('Failed to decode URI component:', e)
      return [source]
    }
  }

  private renderGlobeRemoteTilesets(): JSX.Element {
    if (!this.props.mapboxWMSTileset) {
      return null
    }
    return (
      <Source
        key={this.sourceId}
        id={this.sourceId}
        type="raster"
        tiles={this.tiles}
        tileSize={256}
        scheme="xyz"
        volatile={true}
        buffer={0}
      >
        <Layer
          id={this.layerId}
          type="raster"
          source={this.sourceId}
          layout={{
            visibility: this.props.isHidden ? 'none' : 'visible',
          }}
          paint={{
            'raster-fade-duration': 0, // Disable fade to avoid flicker
          }}
        />
      </Source>
    )
  }
}
